import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";          
import Slide from "../components/Slide";
import img1 from "../assets/premium-hardware-fittings-banner.webp";
import img2 from "../assets/banner_one.webp";
import img3 from "../assets/home-banner.webp";
import hinge from "../assets/sus-304.png";
import channel from "../assets/soft-close.webp";
import pipe from "../assets/plain-pipe-basket.png";
import multi from "../assets/multipurpose.webp";
import cor from "../assets/white swing corner 900mm-thumb-two.webp"
import pull from "../assets/stain-masala-pullout.webp"
import p1 from "../assets/one.jpeg";
import img4 from "../assets/gallery.webp";
import img5 from "../assets/quality.webp";
// import "../App.css";
// import "../AllState.css";

const images = [img1, img2, img3];
const SLIDE_TIME = 4000;

function Home() {
  const [current, setCurrent] = useState(0);
  const [next, setNext] = useState(1);
  const [progress, setProgress] = useState(0);
  const [activeFAQ, setActiveFAQ] = useState(null);
const [activeReview, setActiveReview] = useState(0);
  useEffect(() => {
    let start = Date.now();

    const progressTimer = setInterval(() => {
      const elapsed = Date.now() - start;
      const percent = Math.min((elapsed / SLIDE_TIME) * 100, 100);
      setProgress(percent);

      if (percent === 100) {
        start = Date.now();
        setCurrent(next);
        setNext((next + 1) % images.length);
        setProgress(0);
      }
    }, 30);

    return () => clearInterval(progressTimer);
  }, [next]);

const reviews = [
    {
      text: "Slimline products are of excellent quality and the support team is very responsive. We have been using their hardware for our projects and are completely satisfied.",
      name: "Rahul Sharma",
      role: "Interior Designer, Delhi",
    },
    {
      text: "The product quality is excellent and the finishing is very good. Slimline has been a reliable hardware partner for our modular kitchen projects.",
      name: "Amit Verma",
      role: "Kitchen Manufacturer, Mumbai",
    },
    {
      text: "Good quality products, smooth operation and excellent support. We are very happy with the performance of Slimline hardware.",
      name: "Rohit Mehta",
      role: "Architect, Gurgaon",
    },
  ];

  const faqs = [
    {
      question: "Do you supply to dealers and distributors?",
      answer:
        "Yes, Slimline supplies premium kitchen hardware products to dealers, distributors, modular kitchen manufacturers and furniture professionals.",
    },
    {
      question: "Can I request product samples?",
      answer:
        "Product samples may be available depending on the product and requirement. Please contact our team for more information.",
    },
    {
      question: "Do you provide bulk orders?",
      answer:
        "Yes, bulk orders are available for dealers, distributors and business customers.",
    },
    {
      question: "Is there a product catalogue available for download?",
      answer:
        "Please contact Slimline for the latest product catalogue and product information.",
    },
    {
      question: "What is the warranty on your products?",
      answer:
        "Warranty terms depend on the specific product. Please contact our team for product-specific warranty details.",
    },
  ];


useEffect(() => {
    const interval = setInterval(() => {
      setActiveReview((prev) => (prev + 1) % reviews.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [reviews.length]);


// useEffect(() => {
//   const timer = setInterval(() => {
//     setActiveReview((prev) => (prev + 1) % reviews.length);
//   }, 4000);

//   return () => clearInterval(timer);
// }, []);

  return (
     <main className="home">
      {/* ================= HERO SLIDER ================= */}
     <div className="hero">
  {/* Current Image */}
  <img
    src={images[current]}
    alt="Hero Banner"
    className="hero-img active"
    loading="eager"
    fetchPriority="high"
    width="1920"
    height="1080"
  />

  {/* Next Image */}
  <img
    src={images[next]}
    alt="Hero Banner"
    className="hero-img next"
    loading="eager"
    width="1920"
    height="1080"
  />

  <div className="hero-text">
    <div className="mt-8 flex gap-4 justify-center flex-wrap">
    </div>
  </div>


        {/* PROGRESS CIRCLE */}
        <div className="progress-circle">
          <svg  width="50" height="50">
            <circle
              cx="25"
              cy="25"
              r="22"
              stroke="#0e171f"
              strokeWidth="3"
              fill="none"
            />
            <circle
              cx="25"
              cy="25"
              r="22"
              stroke="#faf7f7"
              strokeWidth="3"
              fill="none"
              strokeDasharray="138"
              strokeDashoffset={138 - (138 * progress) / 100}
            />
          </svg>
        </div>
      </div>

     <section id="products" className="products-section">

  <div className="products-heading">
    <span>OUR PRODUCTS</span>
    <h3>Product Categories</h3>
    <p>
      Explore our wide range of kitchen, wardrobe and furniture hardware solutions.
    </p>
  </div>

  <div className="products-grid">

    <Link to="/multiuseBasket" className="product-card">
      <div className="card-content">
        <h4>Kitchen Baskets & Accessories</h4>
        <p>
          Multipurpose kitchen baskets, plate baskets, thali baskets, 
          cup & saucer baskets, cutlery baskets, grain trolleys and more.
        </p>
      </div>
      <span className="arrow-btn">→</span>
    </Link>

    <Link to="/telescopic-channel" className="product-card">
      <div className="card-content">
        <h4>Telescopic Channels & Drawer Runners</h4>
        <p>
          MS black & zinc finish, stainless steel channels, soft-close 
          channels and heavy-duty drawer runners.
        </p>
      </div>
      <span className="arrow-btn">→</span>
    </Link>

    <Link to="/cabinet-hinges" className="product-card">
      <div className="card-content">
        <h4>Cabinet Hinges</h4>
        <p>
          2D hinges, 3D hinges, black hinges, 165° hinges, hydraulic 
          and non-hydraulic cabinet hinges.
        </p>
      </div>
      <span className="arrow-btn">→</span>
    </Link>

    <Link to="/slim-box" className="product-card">
      <div className="card-content">
        <h4>Slim Tandem Box & Drawer Systems</h4>
        <p>
          Premium drawer systems designed for smooth operation, 
          strong load bearing and modern kitchen interiors.
        </p>
      </div>
      <span className="arrow-btn">→</span>
    </Link>

    <Link to="/basket" className="product-card">
      <div className="card-content">
        <h4>Wardrobe Accessories</h4>
        <p>
          Premium wardrobe fittings, pullouts, organizers and smart 
          storage solutions for modern wardrobes.
        </p>
      </div>
      <span className="arrow-btn">→</span>
    </Link>

    <Link to="/door-closer" className="product-card">
      <div className="card-content">
        <h4>Door Hardware</h4>
        <p>
          Door hinges, door closers, screws, fittings and architectural 
          hardware for reliable performance.
        </p>
      </div>
      <span className="arrow-btn">→</span>
    </Link>

    <Link to="/aluminium-profile" className="product-card">
      <div className="card-content">
        <h4>Aluminium Profiles</h4>
        <p>
          High-quality aluminium profiles and hardware solutions 
          suitable for kitchens, wardrobes and furniture applications.
        </p>
      </div>
      <span className="arrow-btn">→</span>
    </Link>

    <Link to="/corner-solutions" className="product-card">
      <div className="card-content">
        <h4>Pull Outs & Corner Solutions</h4>
        <p>
          Smart pullout systems and corner storage solutions designed 
          to maximize space and improve accessibility.
        </p>
      </div>
      <span className="arrow-btn">→</span>
    </Link>

  </div>
</section>
      <hr />
<section className="slm-gallery-section">

  {/* LEFT CONTENT */}
  <div className="slm-gallery-header">

    <span className="slm-gallery-label">
      FEATURED SOLUTIONS
    </span>

    <h2 className="slm-gallery-title">
      Stylish Storage & Display
    </h2>

    <p className="slm-gallery-description">
      Smart storage solutions to make your kitchen and wardrobe
      more organized, functional and beautiful.
    </p>

    <Link to="/kitchen-baskets" className="slm-gallery-button">
      View All Solutions
      <span>→</span>
    </Link>

  </div>


  {/* RIGHT CARDS */}
  <div className="slm-gallery-container">

    {/* CARD 1 */}
    <Link to="/pull-out" className="slm-gallery-card">

      <div className="slm-gallery-img-wrap">
        <img
          src={img4}
          alt="Wardrobe Accessories"
          className="slm-gallery-img"
        />
      </div>

      <div className="slm-gallery-card-info">
        <div>
          <h3>Wardrobe Accessorie</h3>
          <p>Smart storage for a better living</p>
        </div>

        <span className="slm-card-arrow">
          →
        </span>
      </div>

    </Link>


    {/* CARD 2 */}
    <Link to="/pull-out" className="slm-gallery-card">

      <div className="slm-gallery-img-wrap">
        <img
          src={img5}
          alt="Wardrobe Accessories"
          className="slm-gallery-img"
        />
      </div>

      <div className="slm-gallery-card-info">
        <div>
          <h3>Wardrobe Accessorie</h3>
          <p>Smooth, silent and durable</p>
        </div>

        <span className="slm-card-arrow">
          →
        </span>
      </div>

    </Link>

  </div>

</section>




      <Slide/>
{/* ================= ABOUT SLIMLINE ================= */}

<section id="about-slimline" className="about-slimline-section">

  <div className="about-slimline-container">

    {/* ================= LEFT IMAGE ================= */}
    <div className="about-slimline-images">

      <div className="about-main-image">
        <img
          src={p1}
          alt="Slimline Hardware"
          loading="lazy"
        />
      </div>

      <div className="about-thumb-row">
        <div className="about-thumb">
          <img src={p1} alt="Slimline Hardware" />
        </div>

        <div className="about-thumb">
          <img src={p1} alt="Slimline Hardware" />
        </div>

        <div className="about-thumb">
          <img src={p1} alt="Slimline Hardware" />
        </div>
      </div>

    </div>


    {/* ================= CENTER ABOUT CONTENT ================= */}
    <div className="about-slimline-content">

      <span className="about-small-title">
        ABOUT SLIMLINE
      </span>

      <h2>
        Building Better Spaces
        <br />
        with Quality Hardware
      </h2>

      <p>
        Slimline Hardware Fittings is a leading manufacturer and
        supplier of high-quality kitchen, wardrobe and furniture
        hardware. We are committed to innovation, durability and
        customer satisfaction, delivering reliable solutions for
        modern living spaces.
      </p>


      {/* STATS */}
      <div className="about-stats">

        <div className="about-stat">
          <strong>15+</strong>
          <span>Years of Experience</span>
        </div>

        <div className="about-stat">
          <strong>500+</strong>
          <span>Product Range</span>
        </div>

        <div className="about-stat">
          <strong>10,000+</strong>
          <span>Happy Customers</span>
        </div>

        <div className="about-stat">
          <strong>Pan India</strong>
          <span>Distribution Network</span>
        </div>

      </div>


      <Link to="/about" className="about-learn-btn">
        Learn More About Us
        <span>→</span>
      </Link>

    </div>


    {/* ================= RIGHT WHY CHOOSE ================= */}
    <div className="about-why-box">

      <h3>Why Choose Slimline</h3>

      <div className="about-why-item">

        <div className="why-icon">♧</div>

        <div>
          <h4>Premium Quality</h4>
          <p>Durable & reliable products</p>
        </div>

      </div>


      <div className="about-why-item">

        <div className="why-icon">✧</div>

        <div>
          <h4>Innovation & Design</h4>
          <p>Modern & functional solutions</p>
        </div>

      </div>


      <div className="about-why-item">

        <div className="why-icon">⚙</div>

        <div>
          <h4>Smooth Operation</h4>
          <p>Seamless performance</p>
        </div>

      </div>


      <div className="about-why-item">

        <div className="why-icon">♧</div>

        <div>
          <h4>Dedicated Support</h4>
          <p>For dealers & bulk buyers</p>
        </div>

      </div>

    </div>

  </div>

</section>

{/* ================= FAQ SECTION ================= */}

{/* =========================================
    CUSTOMER REVIEW + FAQ
========================================= */}

  <section className="slim-review-faq">

      <div className="slim-review-faq-inner">

        {/* ================= LEFT ================= */}
        <div className="slim-reviews">

          <div className="slim-section-heading">
            <h2>What Our Customers Say</h2>

            <p>
              Trusted by professionals across India.
            </p>
          </div>


          {/* REVIEW SLIDER */}
          <div className="slim-review-box">

            <button
              className="slim-review-arrow slim-review-left"
              onClick={() =>
                setActiveReview(
                  (activeReview - 1 + reviews.length) % reviews.length
                )
              }
            >
              ‹
            </button>


            <div className="slim-review-content">

              <div className="slim-quote">
                “
              </div>

              <p className="slim-review-text">
                {reviews[activeReview].text}
              </p>

              <div className="slim-review-person">
                <strong>
                  {reviews[activeReview].name}
                </strong>

                <span>
                  {reviews[activeReview].role}
                </span>
              </div>

            </div>


            <button
              className="slim-review-arrow slim-review-right"
              onClick={() =>
                setActiveReview(
                  (activeReview + 1) % reviews.length
                )
              }
            >
              ›
            </button>

          </div>


          {/* DOTS */}
          <div className="slim-review-dots">

            {reviews.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveReview(index)}
                className={
                  activeReview === index
                    ? "active"
                    : ""
                }
              />
            ))}

          </div>

        </div>


        {/* ================= RIGHT ================= */}
        <div className="slim-faq">

          <div className="slim-section-heading">

            <h2>
              Frequently Asked Questions
            </h2>

            <p>
              Find quick answers to common queries.
            </p>

          </div>


          <div className="slim-faq-list">

            {faqs.map((faq, index) => {

              const faqNumber = index + 1;

              return (
                <div
                  className={`slim-faq-item ${
                    activeFAQ === faqNumber
                      ? "open"
                      : ""
                  }`}
                  key={faqNumber}
                >

                  <button
                    className="slim-faq-question"
                    onClick={() =>
                      setActiveFAQ(
                        activeFAQ === faqNumber
                          ? null
                          : faqNumber
                      )
                    }
                  >

                    <span>
                      {faq.question}
                    </span>

                    <b>
                      {activeFAQ === faqNumber
                        ? "−"
                        : "+"}
                    </b>

                  </button>


                  {activeFAQ === faqNumber && (
                    <div className="slim-faq-answer">
                      {faq.answer}
                    </div>
                  )}

                </div>
              );

            })}

          </div>

        </div>

      </div>

    </section>


{/* product card */}
 <section className="industry-section">
  <div className="industry-container">

    <div className="industry-heading">
      <span>SOLUTIONS FOR</span>
      <h2>Industries & Professionals</h2>
      <p>
        We serve a wide range of professionals with reliable kitchen hardware solutions.
      </p>
    </div>

    <div className="industry-cards">

      <Link to="/cabinet-hinges" className="industry-card">
        <div className="industry-image">
          <img src={hinge} alt="Hinges" />
        </div>
        <div className="industry-title">
          <h3>Cabinet Hinges</h3>
        </div>
      </Link>

      <Link to="/telescopic-channel" className="industry-card">
        <div className="industry-image">
          <img src={channel} alt="Telescopic Channel" />
        </div>
        <div className="industry-title">
          <h3>Telescopic Channel</h3>
        </div>
      </Link>

      <Link to="/pipe-basket" className="industry-card">
        <div className="industry-image">
          <img src={pipe} alt="Pipe Basket" />
        </div>
        <div className="industry-title">
          <h3>Pipe Basket</h3>
        </div>
      </Link>

      <Link to="/multiuseBasket" className="industry-card">
        <div className="industry-image">
          <img src={multi} alt="Wire Basket" />
        </div>
        <div className="industry-title">
          <h3>Wire Basket</h3>
        </div>
      </Link>

      <Link to="/pull-out" className="industry-card">
        <div className="industry-image">
          <img src={pull} alt="Pull Out" />
        </div>
        <div className="industry-title">
          <h3>Pull Out</h3>
        </div>
      </Link>

      <Link to="/corner-solutions" className="industry-card">
        <div className="industry-image">
          <img src={cor} alt="Corner Solutions" />
        </div>
        <div className="industry-title">
          <h3>Corner Solutions</h3>
        </div>
      </Link>

    </div>

  </div>
</section>



  <section className="enquiry-banner">
      <div className="enquiry-container">

        {/* Left */}
        <div className="enquiry-left">
          <div className="enquiry-icon">
            ✉
          </div>

          <div className="enquiry-text">
            <h3>Need Hardware for Your Project?</h3>
            <p>Get in touch with our team for the best solutions.</p>
          </div>
        </div>

        {/* Right Buttons */}
        <div className="enquiry-actions">
          <a href="/contact" className="enquiry-btn enquiry-btn-light">
            Send Enquiry <span>→</span>
          </a>

          <a
            href="https://wa.me/9650100908"
            className="enquiry-btn enquiry-btn-whatsapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>◉</span> WhatsApp Us
          </a>
        </div>

      </div>
    </section>
    </main>
  );
}

export default Home;